/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      pre: "pre",
      code: "code"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.p, {
        children: "Допустим, дан класс более общего наблюдаемого объекта:"
      }), "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-ts",
          children: "class ConcreteObservable implements Observable {\n  listeners: { [key: string]: Observer[] } = {}\n\n  subscribe(event: string, observer: Observer): void {\n    // добавить объект в this.listeners[event]\n  }\n\n  unsubscribe(event: string, observer: Observer): void {\n    // удалить объект из this.listeners[event]\n  }\n\n  notify(event: string, data: any): void {\n    // уведомить всех из this.listeners[event]\n  }\n}\n"
        })
      }), "\n", _jsx(_components.p, {
        children: "Какой из интерфейсов он реализует?"
      })]
    });
  }
}
export default MDXContent;
